import React, {useEffect, useState} from 'react';
import {Card, Col, Empty, Layout, Row, Segmented, Select, Typography,} from 'antd';
import {useApiSearchMyStudentLessons} from "@/api/lesson";
import StudentLayout from "@/components/layout/student/studentLayout";
import {MyLessonCard} from "@/pages/student/lessons/myLesson/_section/MyLessonCard";
import RenderIf from "@/components/render-if";
import {URLS} from "@/lib/urls";
import SearchInputRaw from "@/components/search/SearchInputRaw";
import {useSearchParams} from "react-router-dom";
import PaginationRaw from "@/components/pagination/PaginationRaw";
import RenderLoading from "@/components/render-if-loading";

const {Header, Content, Sider} = Layout;
const {Title, Text} = Typography;
const {Option} = Select;
const {Meta} = Card;


export default function StudentMyLessonListPage() {

    const [pageTitle, setPageTitle] = useState('تاریخچه کلاس‌ها')
    const [search, setSearch] = useState()
    const [page, setPage] = useState(1)
    const [perPage, setPerPage] = useState(15)
    const [activeLesson, setActiveLesson] = useState('active')
    const [searchParams, setSearchParams] = useSearchParams();
    const {data, isPending} = useApiSearchMyStudentLessons(
        {
            enabled: true,
            search: search,
            per_page: perPage,
            page: page,
            filter: activeLesson
        });


    useEffect(() => {
        if (searchParams.get('filter')) {
            setActiveLesson(searchParams.get('filter'));
        }
    }, [searchParams.get('filter')])

    useEffect(() => {
        if (activeLesson === 'active') {
            setPageTitle('کلاس‌های فعال')
        }
        if (activeLesson === 'today') {
            setPageTitle('کلاس‌های امروز')
        }
        if (activeLesson === 'all') {
            setPageTitle('تاریخچه کلاس‌ها')
        }

    }, [activeLesson]);

    return (
        <>
            <StudentLayout pageTitle={pageTitle} backTo={URLS.student.dashboard}>

                <div className={'mb-2'}>
                    <div className="flex flex-wrap gap-2 justify-between">

                        <SearchInputRaw setSearch={setSearch} setPage={setPage}
                                        placeHolder={'جستجو در لیست درس‌های من ...'}/>
                        <div>
                            <Segmented

                                value={activeLesson}
                                options={[
                                    {label: 'کلاس‌های امروز', value: 'today'},
                                    {label: 'کلاس‌های فعال', value: 'active'},
                                    {label: 'همه کلاس‌ها', value: 'all'},
                                ]}
                                onChange={(value) => {
                                    setActiveLesson(value);
                                }}
                            />
                        </div>
                    </div>
                </div>

                <RenderIf condition={data?.data?.data?.length === 0}>
                    <Empty description={'شما در هیچ درسی ثبت‌نام نکرده‌اید'}></Empty>
                </RenderIf>

                <RenderLoading loading={isPending} spin={true}>


                    <Row gutter={[8, 8]}>
                        {data?.data?.data?.map((item, index) => (
                            <Col
                                span={8}
                                xs={24}
                                sm={24}
                                md={12}
                                lg={12}
                                xl={8}
                                key={'my-lesson' + index + '-id-' + item.id}>
                                <MyLessonCard takeLessonInfo={item}/>
                            </Col>
                        ))}

                    </Row>
                </RenderLoading>
                <PaginationRaw data={data?.data} setPage={setPage} setPerPage={setPerPage}/>

            </StudentLayout>
        </>

    );
}